import React, { useRef, useState } from 'react';
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Container, Row, Col } from 'react-bootstrap';
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const EstablishedCommunity = () => {
  const { t } = useTranslation();

  const sliderRef2 = useRef(null);

  const [lightbox, setLightbox] = useState({
    open: false,
    slides: [],
    index: 0,
  });

  const openLightbox = (slides, index) => {
    setLightbox({
      open: true,
      slides,
      index,
    });
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0px",
    arrows: false, // We are using custom arrows
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };



  const slider2Content = [
    <div className="image-card" key={0}>
      <img src="/images/E6.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/E4.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_20.jpg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/E10.jpg" alt="" />
    </div>,
    <div className="image-card" key={4}>
      <img src="/images/E2.jpg" alt="" />
    </div>,
  ];



  const slides2 = slider2Content.map((card) => ({
    src: card.props.children.props.src,
  }));

  return (
    <Container>
<Row className="section">
        <Col md={7}>
          <Row>
            <div className="sigle-slider ">
              <Slider ref={sliderRef2} {...sliderSettings}>
                {slider2Content.map((card, idx) =>
                  React.cloneElement(card, {
                    onClick: () => openLightbox(slides2, idx),
                  })
                )}
              </Slider>
              <div className="slider-arrows">
                <button
                  className="slick-prev-custom"
                  onClick={() => sliderRef2.current.slickPrev()}
                >
                  <FaArrowLeft />
                </button>
                <button
                  className="slick-next-custom"
                  onClick={() => sliderRef2.current.slickNext()}
                >
                  <FaArrowRight />
                </button>
              </div>
            </div>
          </Row>
        </Col>
        <Col md={5} className="d-flex flex-column justify-content-center">
          <h2>{t("established_main_title")}</h2>
          <p>{t("established_main_p")}</p>
        </Col>
      </Row>
      <Lightbox
        open={lightbox.open}
        close={() => setLightbox({ ...lightbox, open: false })}
        slides={lightbox.slides}
        index={lightbox.index}
      />
    </Container>
  );
};

export default EstablishedCommunity;
